<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="20vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                委派
            </div>
        </div>
        <div class="dialog_body" style="padding: 25px">
            <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px">
                <el-form-item label="委派人员" prop="ASSIGNEE_">
                    <el-input style="width:200px" v-model="form.ASSIGNEE_" placeholder="请输入委派人员" readonly>
                        <el-button slot="append" icon="el-icon-search" @click="selRoleData" class="role">岗位</el-button>
                        <el-button slot="append" icon="el-icon-search" @click="selUserData" class="user">用户</el-button>
                    </el-input>
                </el-form-item>
            </el-form>
            <div style="text-align: center;padding-top: 20px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">委 派</el-button>
            </div>
        </div>

        <selRole v-if="showRoleDialog"
                 :roleData="roleData"
                 :loading="roleLoading"
                 @closeDialog="closeDialog"
                 @checkRow="checkRole">
        </selRole>

        <selUser v-if="showUserDialog"
                 :userData="userData"
                 :loading="roleLoading"
                 @closeDialog="closeDialog"
                 @checkRow="checkUser">
        </selUser>
    </el-dialog>

</template>

<script>
    import selRole from '@/components/system/rolemanage/roleSelect/single'
    import selUser from '@/components/system/usermanage/userSelect/single'

    export default {
        name: "delegate",
        props: ['formData', 'loading'],
        components:{
            selRole,selUser
        },
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',
                rules: {
                    ASSIGNEE_: [
                        {required: true, message: '请选择委派人员', trigger: 'blur'},
                    ],
                },

                roleData:"",
                showRoleDialog: false,
                roleLoading: false,

                userData:"",
                showUserDialog:false,
            };
        },
        async mounted() {
            // this.form = JSON.parse(JSON.stringify(this.form))
        },
        methods: {
            selUserData(){
                this.userData = this.form.ASSIGNEE_;
                this.showUserDialog = true;
            },
            selRoleData() {
                this.roleData = this.form.ASSIGNEE_;
                this.showRoleDialog = true;
            },
            checkRole(row){
                this.form.ASSIGNEE_ = row.rnumber;
                this.showRoleDialog = false;
            },
            checkUser(row){
                this.form.ASSIGNEE_ = row.loginName;
                this.showUserDialog = false;
            },
            closeDialog(){
                this.showRoleDialog = false;
                this.showUserDialog = false;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                this.$refs["formData"].validate((valid) => {
                    if (valid) {
                        this.$emit('submitForm', this.form)
                    } else {
                        this.$message({message: '数据未填完整', type: 'error'});
                    }
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .el-select-dropdown__list li:last-child {
        padding-bottom: 45px;
    }

    .dialog {
        ::v-deep .el-form-item__label {
            background-color: #c8ddf3;
            line-height: 38px;
            text-align: center;
            border: 1px solid rgba(0, 0, 0, 0.1);;
        }

        .bzClass ::v-deep .el-form-item__label {
            line-height: 75px;
            height: 75px;
        }
    }

    .dialog ::v-deep .el-textarea__inner {
        background-color: #daecfa;
    }

    .dialog ::v-deep .el-textarea .el-input__count {
        background-color: #daecfa;
    }

    .dialog ::v-deep .el-form-item__content {
        line-height: 40px;
    }

    .dialog ::v-deep .el-form-item {
        margin-bottom: 6px;
    }

    .dialog ::v-deep .el-form-item__error {
        z-index: 10;
    }

    .dialog ::v-deep .el-input__inner {
        background-color: #daecfa;
        height: 40px;
        line-height: 40px;
    }

    .dialog ::v-deep .el-dialog__header {
        padding: 0;
        text-align: center;
    }

    .dialog ::v-deep .el-dialog__headerbtn {
        top: 8px;
        right: 10px
    }

    .dialog ::v-deep .el-dialog__headerbtn .el-dialog__close {
        color: #FFF;
    }


    .dialog ::v-deep .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 0px;
    }

    .dialog .dialog_title {
        background-color: rgba(28, 136, 201, 0.6);
        padding: 5px 10px 5px;
    }

    .dialog .dialog_body {
        border-left: 10px solid rgba(28, 136, 201, 0.6);
        border-right: 10px solid rgba(28, 136, 201, 0.6);
        border-bottom: 10px solid rgba(28, 136, 201, 0.6);
        background-color: rgba(193, 245, 236, 0.15);
    }

    .dialog ::v-deep .el-input-group__append {
        .role {
            margin-right: 0;
            background-color: rgba(14, 129, 248, 0.48);
            color: #000;
        }

        .user {
            background-color: #e6a23c;
            color: #000;
        }

    }
</style>
